import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthBits";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Esqueci minha senha" subtitle="Digite seu e-mail. Vamos enviar um link para você criar uma nova senha." backTo="/entrar">
      {sent ? (
        <div className="po-card text-lg" data-testid="forgot-sent">
          Se o e-mail estiver cadastrado, você vai receber o link em alguns minutos. Confira também a caixa de spam.
          <Link to="/entrar" className="po-btn-primary mt-4 w-full">Voltar para entrar</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <label className="po-label" htmlFor="femail">E-mail</label>
          <input id="femail" type="email" required className="po-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          <button className="po-btn-primary w-full" data-testid="forgot-submit-button">Enviar link</button>
        </form>
      )}
    </AuthShell>
  );
}
